export default "__VITE_ASSET__e9992a8c__"